import React, { useEffect, useRef } from 'react';

const WidgetSample: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const getNavbarHeight = () => {
      // Account for mobile navigation bar which might be taller on mobile
      const isMobile = window.innerWidth <= 700;
      // Use actual viewport height for mobile (accounts for browser UI)
      return isMobile ? 64 : 64;
    };

    const handleLoad = () => {
      // Wait for iframe content to fully load
      setTimeout(() => {
        try {
          const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
          if (iframeDocument) {
            // Get the scroll height of the iframe content
            const height = Math.max(
              iframeDocument.body.scrollHeight,
              iframeDocument.body.offsetHeight,
              iframeDocument.documentElement.clientHeight,
              iframeDocument.documentElement.scrollHeight,
              iframeDocument.documentElement.offsetHeight
            );
            // Use window.innerHeight for accurate mobile viewport (excludes browser UI)
            const navbarHeight = getNavbarHeight();
            const viewportHeight = window.innerHeight;
            const minHeight = Math.max(viewportHeight - navbarHeight, 400);
            iframe.style.height = `${Math.max(height, minHeight)}px`;
            
            // Ensure iframe width doesn't exceed viewport on mobile
            const isMobile = window.innerWidth <= 700;
            if (isMobile) {
              iframe.style.maxWidth = '100vw';
              iframe.style.width = '100%';
            }
          }
        } catch (e) {
          // Cross-origin or other error - fallback to viewport height
          const navbarHeight = getNavbarHeight();
          iframe.style.height = `${window.innerHeight - navbarHeight}px`;
        }
      }, 100);
    };

    const handleResize = () => {
      // Recalculate height on window resize with debounce for performance
      clearTimeout((handleResize as any).timeout);
      (handleResize as any).timeout = setTimeout(() => {
        handleLoad();
      }, 150);
    };

    iframe.addEventListener('load', handleLoad);
    window.addEventListener('resize', handleResize);

    // Also check periodically in case content loads asynchronously
    const interval = setInterval(() => {
      if (iframe.contentDocument?.readyState === 'complete') {
        handleLoad();
      }
    }, 500);

    return () => {
      iframe.removeEventListener('load', handleLoad);
      window.removeEventListener('resize', handleResize);
      clearTimeout((handleResize as any).timeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <main 
      style={{ 
        width: '100%', 
        maxWidth: '100vw',
        margin: 0, 
        padding: 0,
        overflowX: 'hidden',
        boxSizing: 'border-box',
        position: 'relative',
        minWidth: 0,
      }}
    >
      <iframe
        ref={iframeRef}
        title="Mavrk Widget Builder"
        src="/widget/sample.html"
        style={{
          width: '100%',
          maxWidth: '100vw',
          minHeight: 'calc(100vh - 64px)',
          border: 0,
          display: 'block',
          background: '#000',
          boxSizing: 'border-box',
          overflow: 'hidden',
          minWidth: 0,
        }}
      />
    </main>
  );
};

export default WidgetSample;


